import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./tailwind.css";
import store from "./store";

const app = createApp(App);


// router.beforeEach((to, from, next) => {
//   const publicPages = ["Login", "RegisterUser", "RecoverPassword"];
//   const authRequired = !publicPages.includes(to.name);
//   const userData = JSON.parse(sessionStorage.getItem("userData"));

//   if (authRequired && !userData) {
//     return next({ name: "Login" });
//   }

//   next();
// });

app.use(router);
app.use(store);

app.mount("#app");
